import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../../api/server";

export const loginUser = createAsyncThunk(
  "user/validateOTP",
  async (userCred) => {
    try {
      const response = await http.post("api/Auth/validate-otp", userCred);
      if (response.status === "400") {
        const errorData = await response.json();
        throw new Error(errorData?.data?.message || "Something went wrong!");
      }
      const data = await response;
      var user = {};
      if (data) {
        let userName = userCred.userEmail.split("@")[0];
        let usernameCap = userName.charAt(0).toUpperCase() + userName.slice(1);

        user = {
          data: response.data,
          userEmail: userCred.userEmail,
          userName: usernameCap.replace(/\./g, " "),
        };
      }

      return user;
    } catch (error) {
      throw new Error(error?.data?.message || "Something went wrong!");
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    userObj: null,
  },
  reducers: {
    clearUser: (state) => {
      state.userObj = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.userObj = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.userObj = action.payload;
      })
      .addCase(loginUser.rejected, (state) => {
        state.userObj = null;
      });
  },
});

export default userSlice.reducer;
export const { clearUser } = userSlice.actions;
